"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
/**
 * exemple d'utilisation :<br/>
 *         <tl-menu-button label="Actions">
 *             <tl-menu-item ng-click="openModal()"><span>Ouvre modale</span></tl-menu-item>
 *             <tl-menu-item><a href="/tael/inventaire">Inventaire</a></tl-menu-item>
 *             <tl-menu-item><a href="/tael/reporting"><span>Rapports</span></a></tl-menu-item>
 *         </tl-menu-button>
 */
ngModule.directive("tlMenuButton", function () {
  return {
    restrict: "E",
    transclude: true,
    scope: {
      label: '@'
    },
    template: "\n            <div class=\"tl-menu-button\">\n                <button ng-if=\"nbItems()!=1\" class=\"btn btn-primary\" ng-click=\"toggleMenu()\">\n                    <i class=\"caret\" ng-class=\"{'fa fa-caret-down': !menuVisible, 'fa fa-caret-up': menuVisible}\"></i>{{label}}</button>\n                <ul ng-show=\"menuVisible && nbItems()!==1\" ng-class=\"{'align-right': menuAlignRight}\" ng-transclude></ul>\n                <button ng-if=\"nbItems()==1\" class=\"btn btn-primary single\" ng-transclude></button>\n            </div>\n        ",
    controller: function controller($scope, $element, $document, $timeout, $window) {
      $scope.menuVisible = false;
      $scope.menuAlignRight = false;
      $scope.toggleMenu = function () {
        $scope.menuVisible = !$scope.menuVisible;
        if ($scope.menuVisible) {
          // On utilise $timeout pour s'assurer que le menu est visible et a des dimensions
          // avant de faire les calculs.
          $timeout(function () {
            var ul = $element.find('ul');
            // Le conteneur de référence pour la position est la div interne, pas l'élément de la directive
            var menuContainer = $element.find('div.tl-menu-button');
            if (!ul.length || !menuContainer.length) {
              return;
            }
            var containerRect = menuContainer[0].getBoundingClientRect();
            var ulRect = ul[0].getBoundingClientRect();
            var viewportWidth = $window.innerWidth;

            // Si le menu, aligné à gauche de son conteneur, dépasse de la fenêtre
            if (containerRect.left + ulRect.width > viewportWidth) {
              $scope.menuAlignRight = true;
            } else {
              $scope.menuAlignRight = false;
            }
          }, 0); // En retirant le 'false', $timeout va automatiquement déclencher un $apply()
        }
      };
      $scope.nbItems = function () {
        var entrees = $element.find('ul li');
        return entrees.length;
      };
      var handler = function handler(event) {
        if ($scope.menuVisible && !$element[0].contains(event.target)) {
          $scope.$apply(function () {
            $scope.menuVisible = false;
          });
        }
      };
      $document.on('click', handler);
      $scope.$on('$destroy', function () {
        $document.off('click', handler);
      });
    }
  };
});
ngModule.directive("tlMenuItem", function () {
  return {
    restrict: 'E',
    require: '^tlMenuButton',
    transclude: true,
    template: '<li ng-transclude></li>'
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/buttons/tl-menu-button.js
// module id = 2926
// module chunks = 13